import { render, staticRenderFns } from "./Geonames.vue?vue&type=template&id=4edadfa2&scoped=true&"
import script from "./Geonames.vue?vue&type=script&lang=js&"
export * from "./Geonames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edadfa2",
  null
  
)

export default component.exports